import React, { useContext, useState } from "react";
import { Row, Col, Card, Spinner, Tabs, Tab } from "react-bootstrap";
import Statics from "../Statics";
import ComponentContext from "../Context";
import DocumentMeta from "react-document-meta";
import HeaderBanner from "../Components/HeaderBanner";
import Kargah from "../Images/kargah.png";
import Config from "../config.json";
import { Link } from "react-router-dom";
import Teachers from "./Teachers";
import { useHash } from "../lib/hooks";

const WorkshopMeetingRow = props => {
  const { meetingNo, session } = props;
  return (
    <Row className="mx-0">
      <div className="text-right">
        <span className="mx-1">جلسه {meetingNo} :</span>
        <span>
          {session.start_date.year +
            "/" +
            session.start_date.month +
            "/" +
            session.start_date.day +
            "   " +
            session.start_date.hour +
            ":" +
            ("0" + session.start_date.minute).slice(-2)}
        </span>
        {" تا "}
        <span>
          {session.finish_date.hour +
            ":" +
            ("0" + session.finish_date.minute).slice(-2)}
        </span>
      </div>
    </Row>
  );
};

const page_meta = {
  language: "fa",
  copyright: "پژوهیار",
  description: "نرم‌افزار استناددهی",
  title: Config.title + " | کارگاه",
  meta: {
    charset: "utf-8",
    name: {
      keywords: "پژوهیار",
    },
  },
};

const body = (
  <p>
    به منظور فراگیریِ بهتر پژوهیار، دوره‌های آموزشی در سه سطح در نظر گرفته شده
    است.
    <br />
    برای درخواست کارگاه و کلاس آموزشی از طریق فرم تربیت‌مدرس، فرم سازمانی و فرم
    عمومی ثبت‌نام فرمایید.
  </p>
);

const ACCEPTABLE_HASHES = ["workshop-list", "teacher-list"];

const WorkShop = () => {
  const [workshops, set_workshops] = useState(null);
  const context = useContext(ComponentContext);

  const selectedTab = useHash(ACCEPTABLE_HASHES);

  const [loading_state, set_loading_state] = useState(Statics.NOT_LOADED);

  const getWorkshops = () => {
    set_loading_state(Statics.LOADING);
    context.ApiDriver.searchWorkshops(
      {},
      (data, meta) => {
        set_workshops(data.data);
        set_loading_state(Statics.LOADED);
      },
      error => {
        set_loading_state(Statics.CAUSED_ERROR);
      },
    );
  };

  if (loading_state === Statics.NOT_LOADED) {
    getWorkshops();
  }

  return (
    <DocumentMeta {...page_meta}>
      <HeaderBanner body={body} image={Kargah} header_color="#fdfbb1" />
      <Row className="justify-content-center p-2 mx-0">
        <p className="text-center px-4 py-2">
          برای آشنایی با محورهای آموزشی، تقاضای برگزاری کارگاه، تعهدات مادی و
          معنوی در برابر مخاطبان کارگاه‌ها، هزینه‌های برگزاری کارگاه آموزشی کلیک
          کنید.
        </p>
      </Row>
      <Tabs defaultActiveKey={selectedTab} className="justify-content-center">
        <Tab
          eventKey="teacher-list"
          title={
            <Link
              to={{
                hash: "teacher-list",
              }}
              className="addon-tabs">
              <h3>مدرسین</h3>
            </Link>
          }>
          <Teachers />
        </Tab>

        <Tab
          eventKey="workshop-list"
          title={
            <Link
              to={{
                hash: "workshop-list",
              }}
              className="addon-tabs">
              <h3>کارگاه</h3>
            </Link>
          }>
          <Row className="justify-content-center" style={{ margin: 10 }}>
            <Col>
              <Row className="justify-content-center ">
                <Col md={12} sm={12}>
                  {loading_state === Statics.LOADING ||
                  loading_state === Statics.NOT_LOADED ? (
                    <Row
                      className="justify-content-center"
                      style={{ padding: "5rem 0" }}>
                      <Spinner
                        animation="border"
                        variant="warning"
                        style={{ width: "5rem", height: "5rem" }}
                      />
                    </Row>
                  ) : null}
                  {loading_state === Statics.LOADED ? (
                    <Row className="workshop-list justify-content-center">
                      {loading_state === Statics.LOADED
                        ? workshops.map(workshop => (
                            <Col md={6} lg={3} sm={12} xs={12}>
                              <Row className="workshop-list h-100">
                                <Card key={workshop.id}>
                                  <Card.Body>
                                    <Card.Title>{workshop.title}</Card.Title>
                                    <Card.Text>
                                      <Row className="mx-0">
                                        توضیحات: {workshop.description}
                                      </Row>
                                      <Row className="mx-0">
                                        ظرفیت: {workshop.capacity}
                                      </Row>
                                      <Row className="mx-0">
                                        نوع کارگاه: {workshop.type.text}
                                      </Row>
                                      {workshop.meetings.data.length > 1 ? (
                                        workshop.meetings.data.map(
                                          (session, index) => (
                                            <WorkshopMeetingRow
                                              key={index}
                                              session={session}
                                              meetingNo={index + 1}
                                            />
                                          ),
                                        )
                                      ) : workshop.meetings.data.length ===
                                        1 ? (
                                        <WorkshopMeetingRow
                                          session={workshop.meetings.data[0]}
                                          meetingNo={1}
                                        />
                                      ) : (
                                        <></>
                                      )}
                                      <Row className="mx-0">
                                        <span className="mx-1">قیمت :</span>
                                        {workshop.offered_fee ===
                                        workshop.fee ? (
                                          <b>{workshop.fee} ريال</b>
                                        ) : (
                                          <>
                                            <del style={{ color: "red" }}>
                                              {workshop.fee} تومان
                                            </del>
                                            {"\u00A0"}
                                            <b>{workshop.offered_fee} تومان</b>
                                          </>
                                        )}
                                      </Row>
                                    </Card.Text>
                                  </Card.Body>
                                  <Card.Footer>
                                    <Row className="justify-content-center">
                                      {workshop.type.code === 2 ? (
                                        <Link
                                          to={`/workshop/order/${workshop.id}`}
                                          className="custom-button"
                                          style={{
                                            textAlign: "center",
                                            verticalAlign: "middle",
                                          }}
                                          size="sm">
                                          انتخاب
                                        </Link>
                                      ) : (
                                        <Link
                                          to={`/workshop/register/${workshop.id}`}
                                          className="custom-button"
                                          style={{
                                            textAlign: "center",
                                            verticalAlign: "middle",
                                          }}
                                          size="sm">
                                          انتخاب
                                        </Link>
                                      )}
                                    </Row>
                                  </Card.Footer>
                                </Card>
                              </Row>
                            </Col>
                          ))
                        : null}
                      <Col md={6} lg={3} sm={12} xs={12}>
                        <Row className="workshop-list">
                          <Card>
                            <Card.Body>
                              <Card.Title>کارگاه سازمانی</Card.Title>
                              <Card.Text>
                                <Row className="mx-0">
                                  توضیحات: برگزاری کارگاه برای شرکت‌ها و
                                  سازمان‌ها.
                                </Row>
                              </Card.Text>
                            </Card.Body>
                            <Card.Footer>
                              <Row className="justify-content-center">
                                <Link
                                  to={`/workshop/order`}
                                  className="custom-button"
                                  style={{
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                  }}>
                                  سفارش
                                </Link>
                              </Row>
                            </Card.Footer>
                          </Card>
                        </Row>
                      </Col>
                    </Row>
                  ) : null}
                </Col>
              </Row>
            </Col>
          </Row>
        </Tab>
      </Tabs>
    </DocumentMeta>
  );
};

export default WorkShop;
